module.exports = __webpack_public_path__ + "assets/127fa0b97082303998173351139e9d77.png";